import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ExchangeService {


    constructor(private http: HttpClient) { }

    getExchangeRates() {
        return this.http.get<{ currencyCode: any, exchangeRate: any, exchangeDate: any }[]>(`${environment.apiUrl}/exchange-rate`, { withCredentials: true }).pipe(
            first()
        )
    }
}